import { compareFrontVersions } from 'Helpers'
import { Deserialize } from 'cerialize'
import { SettingKeys } from 'Constants/SettingKeys'
import { SettingModel } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import { ChannelHandler, SocketMessage } from 'Modules/Socket'
import { settingSlice } from 'Modules'

export class FrontChannel implements ChannelHandler {
	public constructor(private readonly dispatch: Callback) {
		this.dispatch = dispatch
	}
	public work(data: SocketMessage): void {
		const version = data?.message?.payload?.data?.version
		if (compareFrontVersions(process.env.VER, version)) {
			this.dispatch(
				settingSlice.actions.setSetting(
					Deserialize({ key: SettingKeys.FRONT, data: { version } }, SettingModel)
				)
			)
		}
	}
}
